import { memo } from "react";

const DOT_DELAYS_MS = [0, 140, 280];

const ThinkingDots = ({
  className = "",
  dotClassName = "h-1 w-1 bg-current",
}: {
  className?: string;
  dotClassName?: string;
}) => (
  <span aria-hidden="true" className={`flex items-center ${className}`}>
    {DOT_DELAYS_MS.map((delay) => (
      <span
        key={delay}
        className={`thinking-dot rounded-full ${dotClassName}`}
        style={{ animationDelay: `${delay}ms` }}
      />
    ))}
  </span>
);

export default memo(ThinkingDots);
